import { Button, Group, Modal, Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { queryClient } from "~/backend/queryClient"
import { CopyToClipboard } from "~/components/CopyToClipboard"
import {
  findCertificateRequestsForSupplierQueryKey,
  FindCertificateRequestsForSupplierResponseDto,
  useDeleteCertificateRequest,
} from "~/gen/api"
import { useAuth } from "~/store/auth-context"

interface Props {
  certificateRequest: FindCertificateRequestsForSupplierResponseDto
  opened: boolean
  close: () => void
}

export const DeleteCertificateRequestModal = ({
  certificateRequest,
  opened,
  close,
}: Props) => {
  const { mutate } = useDeleteCertificateRequest({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries([
          findCertificateRequestsForSupplierQueryKey,
        ])
        close()
      },
    },
  })

  const { isAdmin } = useAuth()

  const { t } = useTranslation("traceability")

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={
        <Text style={{ textAlign: "center" }}>
          {t("certificates.modal.areyousure")}
        </Text>
      }
    >
      {isAdmin && (
        <Stack>
          <Stack gap={2}>
            <CopyToClipboard text={certificateRequest.id.toString()} />
            <Text fw={700} style={{ textAlign: "center" }}>
              {certificateRequest.type.name}{" "}
            </Text>
            <Text style={{ textAlign: "center" }}>
              {certificateRequest.productionSite?.name}
            </Text>
          </Stack>
          <Group justify="center">
            <Button variant="secondary-critical" onClick={close}>
              {t("certificates.modal.no")}
            </Button>
            <Button
              color="violet"
              variant="secondary"
              onClick={() => {
                mutate({
                  certificateRequestId: certificateRequest.id,
                })
              }}
            >
              {t("certificates.modal.yes")}
            </Button>
          </Group>
        </Stack>
      )}
    </Modal>
  )
}
